export const DEFAULT_ACCEPT = '*';
export const DEFAULT_TAB_INDEX = 0;
export const KEY_ENTER = 'Enter';
export const KEY_SPACE = ' ';

export const ATTACHMENT_IMAGE_FILE_TYPES: readonly string[] = ['gif', 'jpg', 'jfif', 'tiff', 'jpeg', 'png'];
